<template>
  <div class="mx-auto mt-[100px] max-w-[1140px] px-[25px] xl:px-0">
    <div class="text-center">
      <div
        id="text_email_integrations"
        class="text-xs font-bold tracking-wide text-[#2D8CFF]"
      >
        MONETIZATION
      </div>

      <h2
        class="px-auto mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Pay-Per-View or Free To Watch.
      </h2>
    </div>

    <div class="lg:flex justify-between mx-auto lg:gap-[50px] mt-[90px]">
      <!-- BLUE BORDER CARD -->

      <div
        class="bg-white shadow-xl rounded-r-[5px] border-l-[4px] border-[#49CCF9] lg:h-[620px] lg:w-[545px] px-[20px] lg:px-[45px] pb-[25px]"
      >
        <img
          loading="lazy"
          class="lg:w-[457px] lg:h-[315px] mx-auto -m-[30px] rounded-[15px] shadow-xl"
          :src="
            $filters.media_path('/images/charge-for-live-stream-access.png')
          "
          alt="Charge for members to access your live streaming webinars."
        />

        <h2
          class="px-auto text-left mt-[50px] text-[35px] font-bold text-[#292d34]"
        >
          Charge to watch your webinar or stream.
        </h2>

        <div class="flex mt-[30px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/turqoise-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Toggle on payments for each stream.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/turqoise-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Connect Stripe payment processor and keep your earnings
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/turqoise-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Members charged with one click
          </p>
        </div>
      </div>

      <!-- YELLOW BORDER CARD             -->

      <div
        class="bg-white shadow-xl mt-[75px] lg:mt-0 rounded-r-[5px] border-l-[4px] border-[#FFC800] lg:h-[620px] lg:w-[545px] px-[20px] lg:px-[45px] pb-[25px]"
      >
        <img
          loading="lazy"
          class="lg:w-[457px] lg:h-[315px] mx-auto -m-[30px] rounded-[15px] shadow-xl"
          :src="$filters.media_path('/images/co-host-on-the-live-stream.png')"
          alt="Make all your live streams free to members to increase engagement."
        />

        <h2
          class="px-auto text-left top-full mt-[50px] text-[35px] font-bold text-[#292d34]"
        >
          Set for Free member registration.
        </h2>

        <div class="flex mt-[30px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/yellow-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Members can watch streams for free easily in their account.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/yellow-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Moderator control panel for help managing stream.
          </p>
        </div>
        <div class="flex mt-[25px]">
          <img
            loading="lazy"
            class="pr-[15px]"
            :src="
              $filters.media_path('/images/yellow-checkmark-button-icon.svg')
            "
            alt="Video upload module to add titles, descriptions, and thumbnails."
          />

          <p class="px-auto top-full my-auto text-sm text-[#292d34]">
            Invite another presenter for multi-person presentation.
          </p>
        </div>
      </div>

      <!-- YELLOW CARD END  -->
    </div>
  </div>
</template>

<!-- SCRIPTS -->

<script></script>

<!-- STYLES -->

<style></style>
